import { render, staticRenderFns } from "./StoryboardOnThumbnail.vue?vue&type=template&id=baff68d4&scoped=true"
import script from "./StoryboardOnThumbnail.vue?vue&type=script&lang=js"
export * from "./StoryboardOnThumbnail.vue?vue&type=script&lang=js"
import style0 from "./StoryboardOnThumbnail.vue?vue&type=style&index=0&id=baff68d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff68d4",
  null
  
)

export default component.exports